__turbopack_context__.v({
  "navBotMobileTrigger": "NavigationBot-module__0qx3XG__navBotMobileTrigger",
  "navBotPanel": "NavigationBot-module__0qx3XG__navBotPanel",
});
